import Button from '@components/Button'
import Prompt from '@components/Prompt'
import { RainbowAvatar } from '@components/RainbowAvatar/RainbowAvatar'
import { Input, Stack, Typography } from '@mui/material'
import React, { FC, useState } from 'react'
import EmojiPicker, { Theme } from 'emoji-picker-react'
import Touchable from '@components/Touchable'
import { useTranslation } from 'react-i18next'

interface Props {
  show: boolean
  name?: string
  emoji?: string
  isEdit?: boolean
  setName: (newName: string) => void
  setEmoji: (newEmoji: string) => void
  onSave: () => Promise<void> | void
  onClose: () => void
}

const WalletDetailsPrompt: FC<Props> = ({
  show,
  name,
  setName,
  emoji,
  setEmoji,
  onSave,
  onClose,
  isEdit,
}) => {
  const [emojisPickerVisible, setEmojisPickerVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { t } = useTranslation()

  const selectEmoji = (newEmoji: string) => {
    setEmoji(newEmoji)
    setEmojisPickerVisible(false)
  }

  const onClick = async () => {
    setIsLoading(true)
    await onSave()
    setIsLoading(false)
  }

  return (
    <Prompt show={show}>
      <Stack alignItems="center" spacing={2}>
        <Typography variant="h6">
          {isEdit
            ? t('walletDetailsPrompt.updateWalletAppearance')
            : t('walletDetailsPrompt.nameNewWallet')}
        </Typography>
        <Touchable onClick={() => setEmojisPickerVisible(true)}>
          <RainbowAvatar avatar={emoji} size={60} />
        </Touchable>
        <Input
          placeholder={t('walletDetailsPrompt.walletNamePlaceholder')}
          value={name}
          onChange={(event) => setName(event.target.value)}
          disableUnderline
          autoFocus
          inputProps={{ style: { textAlign: 'center', fontSize: 18 } }}
        />
        <Stack width="100%">
          <Button
            loading={isLoading}
            variant="rainbow"
            onClick={onClick}
            disabled={!name || isLoading}
            fullWidth
          >
            {isEdit ? t('walletDetailsPrompt.updateWallet') : t('walletDetailsPrompt.createWallet')}
          </Button>
          <Button onClick={onClose} fullWidth>
            {t('common.back')}
          </Button>
        </Stack>
      </Stack>
      <EmojiPicker
        open={emojisPickerVisible}
        width={260}
        height={250}
        theme={Theme.DARK}
        style={{ position: 'absolute' }}
        previewConfig={{ showPreview: false }}
        onEmojiClick={(emoji) => selectEmoji(emoji.emoji)}
        skinTonesDisabled
        searchDisabled
      />
    </Prompt>
  )
}

export default WalletDetailsPrompt
